module.exports = __webpack_public_path__ + "static/media/Montserrat-Regular.9c460951.ttf";